// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__DHGwN","form":"styles_form__7_BRZ","button":"styles_button__Y6tk2"};